//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';

//containers
import {
  Hero,
  WatchItRunYourFreight,
  HowItWorks,
  RunsOnYourStack,
  TheRestOfTheLineup,
  EndCTA,
} from '../containers';

//styles
import {
  PageWrapper,
  SchedulingAndReSchedulingGlobalStyle,
} from './SchedulingAndReScheduling.styles';

const hero = {
  slug: 'scheduling-and-re-scheduling',
  title: 'Scheduling & Re-Scheduling',
  description:
    'Books dock appointments against live carrier and facility availability from the Opendock network — then detects a slipped pickup, rebooks it, and notifies everyone who needs to know.',
  metric: '5–10 min',
  metricLabel: 'saved per appointment',
  // metricSource: 'MEASURED AT SCOTTS MIRACLE-GRO',
};

const watchItRun = {
  title: 'A pickup just slipped',
  stageHeadTitle:
    'The 8am pickup on #LS-52001 just slipped — carrier’s running late.',
  stageHeadMeta: 'Scheduling · #LS-52001',
  rows: [
    {
      time: '07:35:00',
      text: 'Carrier flagged the 8am pickup will slip ~3 hours.',
    },
    {
      time: '07:35:20',
      text: 'Checked dock availability — rebooked the slot for 11:15am.',
    },
    {
      time: '07:35:40',
      text: 'Delivery appointment shifted to hold the same service window.',
    },
    {
      time: '07:35:55',
      text: 'Dock, receiver and customer notified of the new times.',
    },
    {
      time: '07:36:00',
      text: 'Re-scheduled and everyone’s aligned — no missed dock.',
    },
  ],
  summaryText:
    'A late carrier threw off a booked pickup. Loadsmart AI found a new dock slot, shifted the delivery appointment to protect the service window, and notified the dock, receiver and customer — a slipped pickup didn’t cascade into a missed appointment.',
  agentBadge: 'Scheduling Agent',
  escalationTitle: 'Grace-period logic, not guesswork.',
  escalationText:
    'The agent draws a clear line inside the rules a facility sets. Changes that land within an acceptable window get approved and rebooked without escalation. Changes outside it get cancelled and reopened as a new slot automatically, rather than sitting unresolved on the calendar. Nobody has to sit and watch it happen.',
};

const howItWorks = {
  stepsTitleWhite: 'Books against what’s actually open.',
  stepsTitleGradient: 'Then rebooks when reality changes.',
  steps: [
    {
      title: 'Books against live availability',
      description:
        'Draws on real carrier and facility availability from Opendock’s dock, gate and yard network — not a snapshot from this morning.',
    },
    {
      title: 'Detects the slip',
      description:
        'Catches a pickup missing its window continuously, rather than waiting for someone to notice and react.',
    },
    {
      title: 'Rebooks and notifies',
      description:
        'Reschedules against current availability and tells the carrier, the facility and the customer, without anyone working the phones.',
    },
    {
      title: 'Chases the carrier',
      description:
        'Requests a scheduling update when one is needed, and follows up again if the first request goes unanswered.',
    },
  ],
  outcomes: [
    {
      title: 'Dock utilization improves',
      description:
        'Every slot rebooked automatically, instead of sitting empty while someone notices, is a slot that stays productive.',
    },
    {
      title: 'Detention spend drops',
      description:
        'Automatic rescheduling shrinks the window a truck waits from hours to minutes.',
    },
    {
      title: 'On-time delivery moves month over month',
      description:
        'Fewer missed appointments is the direct effect, and it compounds from there.',
    },
  ],
};

const lineupCards = [
  {
    slug: 'tender-failures',
    title: 'Tender Failures',
    description:
      'Cancels and rebooks the slot when a retender changes the carrier.',
  },
  {
    slug: 'tracking-and-status-updates',
    title: 'Tracking & Status Updates',
    description:
      'Runs the same notification loop once the load is on the road.',
  },
  {
    slug: 'document-collection-and-filing',
    title: 'Document Collection & Filing',
    description: 'One of the six agents that make up Loadsmart AI.',
  },
  {
    slug: 'proactive-load-audits',
    title: 'Proactive Load Audits',
    description: 'One of the six agents that make up Loadsmart AI.',
  },
  {
    slug: 'claims-processing',
    title: 'Claims Processing',
    description: 'One of the six agents that make up Loadsmart AI.',
  },
];

function SchedulingAndReScheduling() {
  return (
    <PageWrapper>
      <SchedulingAndReSchedulingGlobalStyle />
      <Navigation theme="dark" />
      <Hero {...hero} />
      <WatchItRunYourFreight {...watchItRun} />
      <HowItWorks {...howItWorks} />
      <RunsOnYourStack />
      <TheRestOfTheLineup cards={lineupCards} />
      <EndCTA agentName="Scheduling & Re-Scheduling" />
      <Footer />
    </PageWrapper>
  );
}

export default SchedulingAndReScheduling;
export { SchedulingAndReScheduling };
